import {DomainStore} from 'shared/store';
import {computed, observable, action} from 'mobx';
import {Goal} from 'stores/performance_goals';
import {auth, t, endpoints, types} from 'shared/core';
import {setupAutosaveDraft, successAlert} from 'shared/tools';
import {Employee} from 'stores/employees';
import _ from 'lodash';

class CreateGoalContainerState {
  store = new DomainStore();
  match;
  history;

  @observable employee;
  @observable goal;
  @observable errors = {};

  receiveProps({match, history}) {
    this.match = match;
    this.history = history;
  }

  @action async load() {
    await this.store._compose([endpoints.EMPLOYEES]);

    this.employee = new Employee(
      this.store._getSingle(types.EMPLOYEE, { id: this.match.params.employeeId })
    );

    this.goal = new Goal();
    await setupAutosaveDraft(
      this.goal,
      {id: 'new', type: types.PERFORMANCE_GOALS.GOAL}
    );
  }

  @action async save() {
    if (this.isEmployee) {
      this.goal.merge({employeeId: auth.employee.id});
    } else {
      this.goal.merge({employeeId: this.match.params.employeeId});
    }

    const {model, errors} = await this.store.post(
      endpoints.PERFORMANCE_GOALS.GOALS,
      types.PERFORMANCE_GOALS.GOAL,
      this.goal
    );

    this.errors = errors;
    if (model) {
      this.history.push(`/${model.id}/view`);
      successAlert(t('goals.Goal successfully created.'));
    }
  }

  @action cancel() {
    this.goal.title = '';
    this.goal.description = '';
    this.goal.startDate = '';
    this.goal.endDate = '';
    this.goal.autosaver.autosave();

    this.history.push(this.backPath);
  }

  @action updateGoal(updatedAttributes) {
    this.goal.merge(updatedAttributes);
    this.goal.autosaver.autosave();
  }

  @computed get title() {
    if (this.isEmployee) {
      return t('goals.Create Goal');
    } else {
      return t('goals.CREATE_GOAL', { employee: this.employee.name });
    }
  }

  @computed get backPath() {
    if (this.isEmployee) {
      return '/my-goals';
    } else {
      return `/employees/${this.match.params.employeeId}`;
    }
  }

  @computed get isEmployee() {
    return _.isEmpty(this.match.params.employeeId);
  }

  @computed get sharedWith() {
    if (this.isEmployee) {
      return t('goals.SHARED_WITH_MANAGER');
    } else {
      return t('goals.SHARED_WITH_EMPLOYEE',  { employeeName: this.employee.name });
    }
  }
}

export default CreateGoalContainerState;
